/**
 * Media Training JS
 */

var trainer_rate;
var person_rate;
var group_rate;
var large_group_rate;
var group_practice_rate;
var custom_markup;
var travel_markup_ctx;
var travel_markup_tx;
var travel_markup_ot;
var ctx_zip = [765, 766, 767, 780, 781, 782, 786, 787, 789];
var tx_zip_min = 750;
var tx_zip_max = 799;

$(function() {
    var checked_val = $('.radio-session').find('.selected').data('value');
    $("#training-select").val(checked_val);

    if ($('body.page-template-page-get-quote').length > 0)  {
            
        trainer_rate = $('#trainer_rate').data('value');
        person_rate = $('#person_rate').data('value');
        group_rate = $('#group_rate').data('value');
        large_group_rate = $('#large_group_rate').data('value');
        group_practice_rate = $('#group_practice_rate').data('value');
        custom_markup = $('#custom_markup').data('value');
        travel_markup_ctx = $('#travel_markup_ctx').data('value');
        travel_markup_tx = $('#travel_markup_tx').data('value');
        travel_markup_ot = $('#travel_markup_ot').data('value'); 
        $('#team_count').hide();
        $('#zip_code').hide();
    }
});

$('#schedule').localScroll();

$('.radio-session .radio').click(function(){
    $(this).parents().find('.radio').removeClass('selected');
    $(this).addClass('selected');
    var checked_val = $('.radio-session').find('.selected').data('value');
    $("#training-select").val(checked_val);       
});

$('.pricing-options .radio').click(function(){
	$(this).parent().siblings(".session-options").removeClass('selected');
    $(this).parent().addClass('selected');
   
    if($("#group").hasClass('selected')){
        $('#team_count').slideDown();
    } else {
        $('#team_count').slideUp();
    }      

     if($("#travel").hasClass('selected')){
        $('#zip_code').slideDown();
    } else {
        $('#zip_code').slideUp();
    }        
});

$( "#groupcnt" ).on( "blur", function() {
    validateTeam();    
});  

$( "#zipcode" ).on( "blur", function() {
    validateZip();
});  

$('#calculate').click(function() {
    
    var teamSet = true;
    var zipSet = true;

    if($("#group").hasClass('selected')) {
        teamSet = validateTeam();
    }

    if($("#travel").hasClass('selected')) {
        zipSet = validateZip();
    }

    console.log('teamset: ' + teamSet + ' zipset: ' + zipSet);
    if(teamSet && zipSet) {
        calcFunction(); 
    } else {
        $('#form-error').parent().addClass('err');
        document.getElementById("form-error").innerHTML = "Errors found - please fix errors before calulating estimate.";
        return false;
    }
}); 

function validateTeam ()
{
    var groupcnt = $('#groupcnt');
    $('#form-error').parent().removeClass('err');
    $('#groupcnt').parent().removeClass('err');
    document.getElementById("err-groupcnt").innerHTML = "";
    document.getElementById("form-error").innerHTML = "";

    if (groupcnt.val() == "") {
        $('#groupcnt').parent().addClass('err');
        document.getElementById("err-groupcnt").innerHTML = "Team count required";
        return false;
    }
  
    var chknum = parseInt(groupcnt.val());
   
    if (isNaN(chknum)) {
        $('#groupcnt').parent().addClass('err');
        document.getElementById("err-groupcnt").innerHTML = "Please enter a valid number";
        return false;
    }

    if (chknum > 200) {
        $('#groupcnt').parent().addClass('err');
        document.getElementById("err-groupcnt").innerHTML = "Maximum team count is 200";
        return false; 
    }

    return true;
}    

function validateZip ()
{
    var zip = $('#zipcode');
    var zipval = 0;
    $('#form-error').parent().removeClass('err');
    $('#zipcode').parent().removeClass('err');
    document.getElementById("form-error").innerHTML = "";
    document.getElementById("err-zipcode").innerHTML = "";

    if (zip.val() == "") {
        $('#zipcode').parent().addClass('err');
        document.getElementById("err-zipcode").innerHTML = "Zip code required";
        return false;
    } 
  
    var chkzip = parseInt(zip.val());
   
    if (isNaN(chkzip)) {
        $('#zipcode').parent().addClass('err');
        document.getElementById("err-zipcode").innerHTML = "Please enter a 5-digit zip code";
        return false;
    } else { 
        var zipval = document.getElementById('zipcode').value;
        if (zipval.length !== 5) {
            $('#zipcode').parent().addClass('err');
            document.getElementById("err-zipcode").innerHTML = "Please enter a 5-digit zip code";
            return false;
        }
    }

    return true;
}

function calcFunction () {
    var attendee_type = "";
    var team_count = 1;
    var mod_group_rate = 0;
    var attendee_cost = 0;
    var duration = "";
    var trainers = 1;
    var customization = "";
    var custom_cost = 0;
    var session_cost = 0;
    var travel_option = "";
    var travel_markup = 0;
    var travel_cost = 0;
    var participation_type = "";
    var participation_cost = 0;
    var estimate_total = 0;
    var final_estimate = 0;
    var zip_code = 0;
    var zip_prefix = 0;
    var retrieve_val = "";
    
    attendee_type = $('#attendees').find('.selected').children().data('value');
    $("#mt-attendees").val(attendee_type);

    team_count = $('#groupcnt').val();

    if (attendee_type == "group") {
    	if (team_count < 25 && team_count > 1) {
    		mod_group_rate = group_rate;
    	} else {
    		mod_group_rate = large_group_rate;
    	}
    }

    if (attendee_type == "individual") {
        $("#mt-team-cnt").val(1);
        attendee_cost = person_rate;
    	trainers = 1;    	
    } else {
        $("#mt-team-cnt").val(team_count);
    	attendee_cost = (mod_group_rate * team_count);
    	trainers = Math.ceil(team_count / 6);
    	if (trainers > 3) {
    		trainers = 3;
    	}
    }
    
    duration = $('#duration').find('.selected').children().data('value');
    $("#mt-duration").val(duration);
    if (duration == "half day") {
    	session_cost = (trainer_rate * 4) * trainers;
    } else {
    	session_cost = (trainer_rate * 8) * trainers;
    }
    
    customization = $('#customize').find('.selected').children().data('value');
    $("#mt-customize").val(customization);

    if (customization == "custom") {
    	custom_cost = custom_markup;
    } 

    participation_type = $('#participate').find('.selected').children().data('value');
    $("#mt-participate").val(participation_type);

    if (participation_type == "practice") {
    	participation_cost = group_practice_rate * team_count;
    } 
    
    travel_option = $('#location').find('.selected').children().data('value');
    $("#mt-location").val(travel_option);

    if (travel_option == "travel") {
        zip_code = $('#zipcode').val();
         $("#mt-zipcode").val(zip_code);
        if (zip_code) {
            zip_prefix = parseInt(zip_code.substring(0, 3));

            if (ctx_zip.includes(zip_prefix)) {
                travel_markup = travel_markup_ctx;
            }
            else if ((zip_prefix >= tx_zip_min) && (zip_prefix <= tx_zip_max)) {
                travel_markup = travel_markup_tx; 
            } else {
                travel_markup = travel_markup_ot;
            }
        }
    }
    
    travel_cost = travel_markup * trainers;

    estimate_total = attendee_cost + session_cost + custom_cost + participation_cost + travel_cost;

    final_estimate = estimate_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    $('#training-estimate').html('<h4 class="u--margin-0"> $' + final_estimate +'</h4>');

    $("#training-select").val('Media Training'); 
    $("#mt-estimate").val(final_estimate);
}



// WEBPACK FOOTER //
// assets/js/training.js